import { render, staticRenderFns } from "./FuelStatisticTrip.vue?vue&type=template&id=0099fb81&"
import script from "./FuelStatisticTrip.vue?vue&type=script&lang=js&"
export * from "./FuelStatisticTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports